import { CustomButton } from '../../../../components/CustomButton';

export function Footer({ deleteMounting, onClose }) {
  return (
    <>
      <CustomButton appearance="ghost" onClick={deleteMounting}>
        Apagar
      </CustomButton>
      <CustomButton onClick={onClose}>Cancelar</CustomButton>
    </>
  );
}
